import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import Modal from 'flarum/common/components/Modal';
export default class SelectMatchModal extends Modal {
  constructor() {
    super(...arguments);
    _defineProperty(this, "matches", []);
    _defineProperty(this, "onSelect", () => {});
    _defineProperty(this, "searchQuery", '');
  }
  oninit(vnode) {
    super.oninit(vnode);
    this.matches = this.attrs.matches || [];
    this.onSelect = this.attrs.onSelect;
  }
  className() {
    return 'SelectMatchModal Modal--small';
  }
  title() {
    return 'Seleccionar Partido';
  }
  content() {
    const dayjs = window.dayjs;
    const filtered = this.matches.filter(m => {
      const name = m.getName() || '';
      const opp = m.opponent() || '';
      const jor = m.jornada() || '';
      return name.toLowerCase().includes(this.searchQuery.toLowerCase()) || opp.toLowerCase().includes(this.searchQuery.toLowerCase()) || jor.toLowerCase().includes(this.searchQuery.toLowerCase());
    }).sort((a, b) => {
      const dateA = a.matchDate() ? new Date(a.matchDate()).getTime() : 0;
      const dateB = b.matchDate() ? new Date(b.matchDate()).getTime() : 0;
      return dateA - dateB;
    });
    const isMobile = window.innerWidth < 768;
    const listMaxHeight = isMobile ? 'calc(100vh - 180px)' : '350px';
    return m("div", {
      className: "Modal-body",
      style: {
        padding: '20px'
      }
    }, m("div", {
      className: "Form-group",
      style: {
        marginBottom: '15px'
      }
    }, m("input", {
      type: "text",
      className: "FormControl",
      placeholder: "Buscar por rival o jornada...",
      value: this.searchQuery,
      oninput: e => {
        this.searchQuery = e.target.value;
        m.redraw();
      },
      style: {
        borderRadius: '8px'
      }
    })), m("div", {
      style: {
        maxHeight: listMaxHeight,
        overflowY: 'auto',
        display: 'flex',
        flexDirection: 'column',
        gap: '8px'
      }
    }, filtered.length === 0 ? m("div", {
      style: {
        textAlign: 'center',
        color: 'var(--muted-color)',
        padding: '20px 0',
        fontStyle: 'italic'
      }
    }, "No se encontraron partidos") : filtered.map(match => {
      const comp = typeof match.competition === 'function' ? match.competition() : null;
      const isNoTxapela = comp && (comp.countsForLineupStanding() === false || comp.countsForBolillaStanding() === false);
      return m("button", {
        type: "button",
        className: "Button SelectMatchModal-item",
        style: {
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'flex-start',
          width: '100%',
          padding: '12px 15px',
          borderRadius: '8px',
          textAlign: 'left',
          border: '1px solid rgba(255,255,255,0.08)',
          background: 'rgba(255,255,255,0.03)',
          transition: 'background 0.2s',
          height: 'auto'
        },
        onclick: () => {
          this.onSelect(match);
          this.hide();
        }
      }, m("div", {
        style: {
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
          flexWrap: 'wrap',
          width: '100%'
        }
      }, m("strong", {
        style: {
          fontSize: '1.05em',
          color: 'var(--heading-color)'
        }
      }, match.getName()), comp && m("span", {
        className: "Badge",
        style: {
          background: comp.color() || '#ee2524',
          color: '#fff',
          fontSize: '0.75em',
          padding: '2px 6px',
          borderRadius: '4px',
          fontWeight: 'bold'
        }
      }, comp.shortName() || comp.name()), isNoTxapela && m("span", {
        className: "Badge",
        style: {
          background: 'rgba(255, 193, 7, 0.15)',
          color: '#ffc107',
          fontSize: '0.75em',
          padding: '2px 6px',
          borderRadius: '4px',
          border: '1px solid rgba(255, 193, 7, 0.3)'
        }
      }, "No computable Txapela")), m("span", {
        style: {
          fontSize: '0.85em',
          color: 'var(--muted-color)',
          marginTop: '4px',
          display: 'block'
        }
      }, m("i", {
        className: "far fa-calendar-alt",
        style: {
          marginRight: '6px'
        }
      }), dayjs(match.matchDate()).format('LLL')));
    })));
  }
}
flarum.reg.add('nagusi-match-ratings', 'forum/aurrera-jokoak/SelectMatchModal', SelectMatchModal);